import { COMPANY_VIDEOS } from '../lib/business';

export const CompanyGallery = ({ compact = false }) => (
  <div className={`grid gap-6 ${compact ? 'md:grid-cols-3' : 'lg:grid-cols-2'}`} data-testid="company-gallery">
    {COMPANY_VIDEOS.map((video, index) => (
      <figure key={video.id} className={!compact && index === 0 ? 'lg:col-span-2' : ''}>
        <video controls playsInline preload="none" poster={video.poster} className="aspect-video w-full rounded-2xl bg-slate-900 object-contain" data-testid={`company-video-${video.id}`} aria-label={video.title}>
          <source src={video.src} type="video/mp4" />
          Your browser does not support this video.
        </video>
        <figcaption className="mt-3 text-sm font-semibold text-slate-700" data-testid={`company-video-caption-${video.id}`}>{video.title} <span className="font-normal text-slate-500">/ Company-supplied footage</span></figcaption>
      </figure>
    ))}
  </div>
);
